/*
 * Pointer-tracked holo foil + tilt for product cards.
 *
 * The foil gradient and the tilt angle both follow the cursor, so hovering a
 * card feels like angling a physical card against the light. Listeners are
 * delegated from the document so cards added later (pagination, filtering,
 * quick-add re-renders) work without re-binding.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAX_TILT = 7; // degrees; beyond this the text starts to smear

  // Folio sections only. Listing pages use the plain card, which neither
  // tilts nor carries the foil layer this drives.
  var FOLIO_CARD = '.tcg-folio .card-wrapper';

  function onMove(event) {
    if (!(event.target instanceof Element)) return;
    var wrapper = event.target.closest(FOLIO_CARD);
    if (!wrapper) return;

    var card = wrapper.querySelector('.card');
    if (!card) return;

    var rect = card.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var px = (event.clientX - rect.left) / rect.width;
    var py = (event.clientY - rect.top) / rect.height;

    card.style.setProperty('--holo-x', (px * 100).toFixed(1) + '%');
    card.style.setProperty('--holo-y', (py * 100).toFixed(1) + '%');

    // Keep the translateZ(0) prefix the stylesheet establishes: matching
    // function lists let the browser interpolate per-function rather than
    // decomposing matrices, which is what made the box jump.
    card.classList.add('is-tilting');
    card.style.transform =
      'translateZ(0) ' +
      'rotateY(' + ((px - 0.5) * MAX_TILT * 2).toFixed(2) + 'deg) ' +
      'rotateX(' + ((0.5 - py) * MAX_TILT * 2).toFixed(2) + 'deg) ' +
      'translateY(-4px)';
  }

  function onLeave(event) {
    if (!(event.target instanceof Element)) return;
    var wrapper = event.target.closest(FOLIO_CARD);
    if (!wrapper) return;

    // pointerout bubbles, so it also fires when crossing between elements
    // inside the same card. Only reset once the pointer has actually left.
    var to = event.relatedTarget;
    if (to instanceof Element && wrapper.contains(to)) return;

    var card = wrapper.querySelector('.card');
    if (!card) return;

    // Drop the inline transform so the stylesheet's translateZ(0) resumes,
    // and re-enable easing so the card settles back rather than snapping.
    card.classList.remove('is-tilting');
    card.style.transform = '';
  }

  document.addEventListener('pointermove', onMove, { passive: true });
  document.addEventListener('pointerout', onLeave, { passive: true });
})();
